import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";

export default function FAQSection({ items = FAQS }) {
  return (
    <section data-testid="faq-section" className="section-pad">
      <div className="container-page grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <p className="overline mb-3">Common questions</p>
          <h2 className="heading-2">Honest answers, no fluff.</h2>
          <p className="body-base mt-5 max-w-sm">
            Don't see your question? Call us at 818-606-3769 — we'll talk it through.
          </p>
        </div>
        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="border-t border-brand-line">
            {items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-brand-line"
              >
                <AccordionTrigger className="text-left font-heading text-lg md:text-xl font-bold text-brand-ink hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-brand-ash text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
